import type { TermsAndConditionsOptionModel } from './types';

export const dependentOptions: Record<string, string> = {
  AllowContactByPhone: 'AllowContact',
};

export const NoticeCountriesList = [
  'BO',
  'BW',
  'BI',
  'CM',
  'CF',
  'TD',
  'CI',
  'CD',
  'DO',
  'EC',
  'SV',
  'GQ',
  'ER',
  'GA',
  'GM',
  'GN',
  'HN',
  'JM',
  'LS',
  'LY',
  'MO',
  'MW',
  'ML',
  'MR',
  'NE',
  'PY',
  'RW',
  'SC',
  'SD',
  'SY',
  'TZ',
  'TG',
  'TT',
  'UG',
  'US',
  'YE',
  'ZM',
  'ZW',
];

export const NoticeCountriesMarketingModels: TermsAndConditionsOptionModel[] = [
  {
    Selected: true,
    Id: 'AllowContact',
    IsReadonly: false,
  },
];
